import { BareButton } from '@calendly/ui/components/bare-button';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { OptionUI } from '@calendly/ui/components/select';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SearchableSelectField } from './searchable-select-field';
const columnCss = "c1s6pm1h";
export const Column = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(columnCss, props.className)} />;
});
const statusBadgeCss = "s1dr45dd";
export const StatusBadge = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(statusBadgeCss, props.className)} />;
});
const deleteButtonCss = "dew5naz";
export const DeleteButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(deleteButtonCss, props.className)}>
    <DeleteIcon />
  </BareButton>);
const styledSearchableSelectFieldIsNotPhoneCss = "s1tymal1";
const styledSearchableSelectFieldCss = "s9tgaau";
export const StyledSearchableSelectField = forwardRef((props, ref) => {
  const isNotPhone = !useDeviceType('isPhone');
  return <SearchableSelectField ref={ref} {...props} className={classNames(styledSearchableSelectFieldCss, {
    [styledSearchableSelectFieldIsNotPhoneCss]: isNotPhone
  }, props.className)} />;
});
const styledCreateGroupOptionCss = "sfzqozr";
export const StyledCreateGroupOption = forwardRef((props, ref) => <OptionUI ref={ref} {...props} className={classNames(styledCreateGroupOptionCss, props.className)} />);

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");